import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import HealthHumanServicesDetails from '../mendepartmentdetails/HealthHumanServices'


function HealthHumanServices() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Health and Human Services || State of GTS";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="home"
            title="Health Human Services"
            subtitledown="Department of Health & Human Services"
           />
            <HealthHumanServicesDetails/>
        </div>
    </>
  )
}

export default HealthHumanServices